export const HANDLE_SERVICES_LINK_LOADING = 'LINK_SERVICES/HANDLE_SERVICES_LINK_LOADING';
export const SET_SERVICES_LINK_ERRORS = 'LINK_SERVICES/SET_SERVICES_LINK_ERRORS';
export const CLEAR_SERVICES_LINK_ERRORS = 'LINK_SERVICES/CLEAR_SERVICES_LINK_ERRORS';